import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function MinMaxValues(props) {
  const renderMinMax = () => (
    <div className={`${style.minmax_wrapper} ${props.className}`}>
      <span tabIndex={0}>{props.min}</span>
      <span tabIndex={0}>{props.max}</span>
    </div>
  );
  const renderDisplay = () => {
    switch (props.valueType) {
      case 'precise':
        return renderMinMax();
      case 'vague':
        return <div></div>;
      default:
        return renderMinMax();
    }
  };
  return renderDisplay();
}

MinMaxValues.propTypes = {
  /**
   * value to be displayed on left (lowerbound)
   */
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * value to be displayed on right (upperbound)
   */
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * classname
   */
  className: PropTypes.string,
};
